import { useEffect, useState } from 'react';

export const useResponsiveTagsCount = (): number => {
  const [maxVisibleTags, setMaxVisibleTags] = useState<number>(() => {
    if (typeof window === 'undefined') return 3;
    return window.innerWidth <= 1440 ? 2 : 3;
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setMaxVisibleTags(width <= 1440 ? 2 : 3);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return maxVisibleTags;
};
